import React from 'react';
import PropTypes from 'prop-types';

import ReactPlayer from 'react-player';
import { useConfigStore } from '../../stores';

const Player = ({
  url, className, autoplay, muted,
}) => {
  const config = useConfigStore((state) => state.config);
  const { primaryColor = '000000' } = config || {};

  return (
    <ReactPlayer
      url={url}
      className={className}
      width="100%"
      height="100%"
      controls
      muted={muted}
      playing={autoplay}
      config={{
        youtube: {
          playerVars: {
            enablejsapi: 1,
            modestbranding: 1,
            rel: 0,
            iv_load_policy: 3,
            autoplay: autoplay ? 1 : 0,
            controls: 1,
            color: primaryColor,
          },
        },
        vimeo: {
          playerOptions: {
            autoplay,
            color: primaryColor,
            title: false,
            portrait: false,
            autopause: true,
            controls: true,
          },
        },
        wistia: {
          options: {
            playerColor: primaryColor,
            videoFoam: true,
            autoPlay: autoplay,
            controlsVisibleOnLoad: true,
            playBar: true,
          },
        },
      }}
    />
  );
};

Player.propTypes = {
  url: PropTypes.string.isRequired,
  className: PropTypes.string,
  autoplay: PropTypes.bool,
  muted: PropTypes.bool,
};

Player.defaultProps = {
  className: null,
  autoplay: false,
  muted: false,
};

export default Player;
